import { NavLink } from './NavLink';

export * from './NavLink';

export default NavLink;
